import React, { useState, useEffect } from 'react';
import { useEmailStyles } from '../../../components/Context/EmailStyleContext';
import { Edit, Settings, Trash } from 'lucide-react';
import StyleControls from '../EmailModelComponents/StyleControls';

const BaseEmailSection = ({
  id,
  title,
  children,
  onRemove,
  onEdit,
  onSettings,
  previewMode = false,
  className = '',
  showAdvancedSettings = false,
}) => {
  const { styles } = useEmailStyles();
  const [hovered, setHovered] = useState(false);
  
  // Log styles when they change for debugging
  useEffect(() => {
    console.log('BaseEmailSection: Current styles', styles);
  }, [styles]);
  
  // Apply styles from context or use fallbacks
  const sectionStyle = {
    fontFamily: styles?.fontFamily || 'helvetica, "helvetica neue", arial, verdana, sans-serif',
    marginBottom: '20px',
    padding: previewMode ? '10px' : '15px',
    border: !previewMode && hovered ? '1px dashed #007bff' : !previewMode ? '1px solid #dee2e6' : 'none',
    borderRadius: '4px',
    position: 'relative',
    transition: 'border 0.2s'
  };
  
  const titleStyle = {
    color: styles?.secondaryColor || '#a1894c',
    margin: 0
  };
  
  return (
    <div 
      id={id}
      className={`email-section ${className}`}
      style={sectionStyle}
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
    >
      {!previewMode && (
        <div className="section-header d-flex justify-content-between align-items-center mb-3 flex-wrap gap-2">
          <h5 className="section-title m-0" style={titleStyle}>{title}</h5>
          
          <div className="section-controls d-flex gap-2 align-items-center flex-wrap">
            {id && (
              <StyleControls 
                id={id} 
                componentName={title || "Section"}
                styleSettings={{
                  primaryColor: styles?.primaryColor || "#333333",
                  secondaryColor: styles?.secondaryColor || "#a1894c",
                  backgroundColor: styles?.backgroundColor || "#ffffff",
                  fontFamily: styles?.fontFamily || 'helvetica, "helvetica neue", arial, verdana, sans-serif'
                }}
                previewMode={previewMode}
              />
            )}
            
            {onEdit && (
              <button 
                className="btn btn-sm btn-outline-primary"
                onClick={onEdit}
                title="Edit Section"
              >
                <Edit size={14} />
              </button>
            )}
            
            {showAdvancedSettings && onSettings && (
              <button
                className="btn btn-sm btn-outline-secondary"
                onClick={onSettings}
                title="Advanced Settings"
              >
                <Settings size={14} />
              </button>
            )}
            
            {onRemove && (
              <button
                className="btn btn-sm btn-outline-danger"
                onClick={onRemove}
                title="Remove Section"
              >
                <Trash size={14} />
              </button>
            )}
          </div>
        </div>
      )}
      
      <div className="section-content">
        {children}
      </div>
    </div>
  );
};

export default BaseEmailSection; 